import React from 'react';
import noop from 'lodash/noop';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const DevDetailDialogLoaderWithContainer = lazy(
	() => import(/* webpackChunkName: "async-dev-panel-details-loader" */ './index-old'),
	{ ssr: false },
);
/**
 * @deprecated - Use the DevDetailsDialogLoader (sync) component instead (in /index.tsx).
 */
export const DevDetailsDialogLoaderAsync: {
	(props: Props): React.JSX.Element;
	defaultProps: {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		onCloseDevDetailDialog: (...args: any[]) => void;
	};
} = (props: Props): React.JSX.Element => (
	<Placeholder name="dev-detail-dialog-loader-with-container" fallback={<></>}>
		<DevDetailDialogLoaderWithContainer {...props} />
	</Placeholder>
);

DevDetailsDialogLoaderAsync.defaultProps = {
	onCloseDevDetailDialog: noop,
};
/**
 * @deprecated - Use the DevDetailsDialogLoader (sync) component instead (in /index.tsx).
 */
export default DevDetailsDialogLoaderAsync;
